import { t } from 'typy'

export function toKebabCase (string) {
    if (!t(string).isString) return

    const regEx = /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g

    return string.trim() ? string.match(regEx).map(c => c.toLowerCase()).join('-') : ''
}
